import { render, staticRenderFns } from "./admin_tools_dashboard.vue?vue&type=template&id=9d59d4a0&scoped=true&"
import script from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
export * from "./admin_tools_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin_tools_dashboard.vue?vue&type=style&index=0&id=9d59d4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d59d4a0",
  null
  
)

export default component.exports